import { useFeatureFLags } from '~/hooks/useFeatureFlags';
import { FCC } from '~/utils/types';
import Header from './header/Header';
import { SupportFooter } from './shared/support-footer/SupportFooter';

/**
 * Renders static info when flag enabled, otherwise renders children
 */
export const MaintenanceMode: FCC = ({ children }) => {
  const enableMaintenanceMode = useFeatureFLags().rtvWebMaintenanceMode === true;
  if (enableMaintenanceMode) {
    return (
      <div>
        <Header />
        <article style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1rem' }}>
          <h1>Vi oppdaterer nettsiden</h1>
          <p>Vi utfører nødvendig vedlikehold på nettsiden vår. Prøv igjen litt senere, så skal alt være i orden.</p>
        </article>
        <div style={{ position: 'fixed', bottom: 0, width: '100%' }}>
          <SupportFooter />
        </div>
      </div>
    );
  }
  return children;
};
